import server from './server'

// export { default as basic } from './basic';
// export { default as random } from './random';


export const ai = server('ai');
export const basic = server('basic');
// export const kingkong = server('kingkong')
// export const heer8 = server('heer8')
// export const pkai = server('pkai')

export const dict = [
    // { label: "50/50", module: "_5050" },
    // { label: "สุ่ม", module: "random", note: 'สุ่มล้วน ๆ ไม่แนะนำ' },
    { label: "Basic", module: "basic", note: '(ฟรี) พื้นฐาน', free: true, default: true },
    { label: "AI", module: "ai", note: 'ประมวลผลด้วย AI [VIP]', default: true, },
    // { label: "สูตรคิงคอง", module: "kingkong", note: 'โดยคิงคองพารวย [VIP]',  },
    // { label: "สูตรเฮียแปด", module: "heer8", note: 'โดยเฮียแปด [VIP]',  },
    // { label: "สูตรพี่ไก่", module: "pkai", note: 'โดยพี่ไก่ปอยเปต [VIP]',  },
]

